// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../index';

import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const CustomerExistsDocument = `
    query customerExists($email: Email!) {
  customerExists(email: $email)
}
    `;

export function useCustomerExistsQuery(options?: Omit<Urql.UseQueryArgs<never, SchemaTypes.CustomerExistsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<SchemaTypes.CustomerExistsQuery, SchemaTypes.CustomerExistsQueryVariables | undefined>({ query: CustomerExistsDocument, variables: undefined, ...options });
};